import React, { useEffect, useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Wrapper from '../../components/Wrapper';
import axiosInstance from '../../utils/axios';
import { getRole } from '../../utils/role';
import { hasPermission } from '../../hooks/usePermission';

const ListPractice = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [practice, setPractice] = useState([]);
    const role = getRole();

    

    useEffect(() => {
        const getPractice = async (fid) => {
            try {
                let url = '';
                if (role === 'FIELD_OFFICER') {
                    url = `/field-officer/${fid}/practice`;
                } else {
                    url = `super-admin/${fid}/practice`;
                }

                const response = await axiosInstance.get(url);
                console.log('Practice fetched Successfully');
                setPractice(response.data.data || []);
            } catch (error) {
                console.log(error);
            }
        };

        getPractice(id);
    }, [id,role]);

    return (
        <Wrapper>
            <div className='py-4'>
                <div className='d-flex flex-column flex-md-row justify-content-between mb-3 w-100'>
                    <h1 className='fw-bolder'>Practice</h1>
                    <div className='d-flex justify-content-end align-items-center position-relative mt-3 m-md-0'>
                        {hasPermission('practices:add') && (
                            <div className='position-relative mx-2'>
                                <Button
                                    variant='primary'
                                    className='rounded-end'
                                    onClick={() => navigate(`/user/practice/add/${id}`)} 
                                >
                                    Add Practice
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
                <div>
                    {(!practice || practice.length === 0) ? (
                        <h3>No Practice Found</h3>
                    ) : (
                        <>
                            <h3>{`${practice.length} Practice Found `}</h3>
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Crop</th>
                                        <th>Profit</th>
                                        <th>Profit per Unit</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {practice.map((item, index) => (
                                        <tr key={item.id || index}>
                                            <td>{index + 1}</td>
                                            <td>{item.crop}</td>
                                            <td>{item.profit}</td>
                                            <td>{item.profit_per_unit}</td>
                                            <td>
                                                <Button 
                                                    variant='primary'
                                                    onClick={() => navigate(
                                                        role === 'FIELD_OFFICER'
                                                        ? `/farmer/practice/${item.id}`
                                                        : `/users/practice/${item.id}`
                                                    )}
                                                >
                                                    View
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </>
                    )}
                </div>
            </div>
        </Wrapper>
    );
};

export default ListPractice;